import { Api } from "@/core/services/api.service";
import { ImportMapper } from "@/apps/dashboard/catalog/core/infrastructure/repository/mapper/importMapper";

export const listImports = async (accountId: string, page: number = 1): Promise<ImportsListResponse> => {
  const response = await Api.new().get<ImportsListResponse>(`/accounts/${accountId}/imports?page=${page}`, {
    account_id: accountId,
    page: page,
  });

  return {
    results: response.data.results.map((importResponse: ImportResponse) => ImportMapper.toModel(importResponse)),
    pagination: response.data.pagination,
  };
};

type ImportsListResponse = {
  results: ImportResponse[];
  pagination: Pagination;
};

export type Pagination = {
  current_page: number;
  total_pages: number;
  results_per_page: number;
  total_results: number;
};

type NamedIdResponse = {
  id: string;
  common_name: string;
};
type UserResponse = {
  id: string;
  name: string;
};
type LineCountResponse = {
  found: number;
  inserted: number;
  updated: number;
  ignored: number;
};
type ReportResponse = {
  error: string | null;
  lines_count: LineCountResponse;
  ignored_lines: string[];
};

export type ImportResponse = {
  id: string;
  origin: string;
  created_at: string | null;
  destination_account: NamedIdResponse | null;
  source_account: NamedIdResponse | null;
  created_by: UserResponse | null;
  status: string | null;
  content: string | null;
  strategy: string | null;
  queued_at: string | null;
  started_at: string | null;
  ended_at: string | null;
  report: ReportResponse | null;
};
